<div class="sd-html col-10" id="details_list">
  <h4>{{title}}</h4>

  <div class="details-list-header row" *ngIf="showColumnsTitles">
    <div [style]="withExpandButton ? 'width: 20px;' : ''"></div>
    <div class="details-list-first-column col-8">{{columns[0]}}</div>
    <div class="details-list-second-column col-3">{{columns[1]}}</div>
  </div>

  <div *ngFor="let item of itemsList" class="">
      <div class="details-list-main-item row">
        <div class="" [style]="useWidth(item) ? 'width: 20px;' : ''" (click)="toggleDetails(item)">
          <label class="details-list-toggle-label" *ngIf="useExpandButton(item)">{{ item.showDetails ? '-' : '+' }}</label>
        </div>
        <div class="col-8" [innerHTML]="item.firstValue"></div>      
        <div class="details-list-item-amount col-3" [innerHTML]="item.secondValue"></div>
      </div>   
    <div class="" *ngIf="item.showDetails">
      <div *ngFor="let detail of item.details">
        <div [ngClass]="detail.id % 2 === 0 ? 'details-list-row-white row' : 'details-list-row-gray row'">
          <div [style]="useWidth(item) ? 'width: 20px;' : ''"></div>
          <div class="details-list-detail-label col-8" [ngClass]="{'details-list-detail-label-with-expand-button': useExpandButton(item)}" [innerHTML]="detail.firstValue"></div>
          <div class="details-list-detail-amount col-3"[innerHTML]="detail.secondValue"></div>
        </div>
      </div>
    </div>
  </div>
  <div class="row" ><hr></div>
  <div class="row justify-content-end" [innerHTML]="footer"></div>
</div>
<tg-spinner [blockAll]="true" *ngIf="isItLoading()"></tg-spinner>
